import React, { useState } from "react";
import { Form, Upload, Input, Button, Checkbox } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { notificationMessage, notificationTitle, openNotificationType, } from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
const { TextArea } = Input;

const OtherDetails = ({ formRef, disabled, initialValues }) => {

    return (
        <>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="remarks" label="Remarks">
                    <TextArea
                        showCount
                        placeholder="Enter Remarks"
                        style={{ height: "100%" }}
                        maxLength={1000}
                        disabled={disabled} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="packing_list"
                    valuePropName="fileList"
                    label="Packing List"
                    rules={[{ required: true, message: "Please upload packing list" }]}
                    extra={"Max. 3 files (.pdf/.xlsx) | Upto 10 MB."}
                    getValueFromEvent={(e) => e.fileList}
                >

                    <Upload name="logo"
                        listType="picture"
                        disabled={disabled}
                        beforeUpload={(file, fileList) => {
                            let ext = file.name.split(".").at(-1);
                            if (!["pdf", "xlsx"].includes(ext)) {
                                openNotification(
                                    openNotificationType.error,
                                    notificationTitle.form,
                                    notificationMessage.fileTypeNotAllowed
                                );
                                return Upload.LIST_IGNORE;
                            }
                            let kb = file.size / 1000;
                            let mb = kb / 1000;
                            if (mb > 11) {
                                openNotification(
                                    openNotificationType.error,
                                    notificationTitle.form,
                                    notificationMessage.fileSizeExceeded
                                );
                                return Upload.LIST_IGNORE;
                            }
                            return false;
                        }}
                        onChange={({ file, fileList, event }) => {
                            if (fileList.length > 3) {
                                openNotification(
                                    openNotificationType.error,
                                    notificationTitle.form,
                                    notificationMessage.fileLimitExceeded
                                );
                                fileList.pop();
                            }
                        }}
                    >
                        <Button disabled={disabled} icon={<UploadOutlined />}>
                            Click to upload
                        </Button>
                    </Upload>
                </Form.Item>
            </div>

        </>
    )
}

export default OtherDetails;